import { Component, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutLoginComponent } from '@spartacus/checkout/base/components';
import { AuthRedirectService, AuthRedirectStorageService, SemanticPathService } from '@spartacus/core';
import { CustomFormValidators } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { CustomValidators } from '../../../../../custom/shared/utils/validators/custom-validators';

@Component({
  selector: 'app-custom-checkout-login',
  templateUrl: './custom-checkout-login.component.html',
  standalone: false
})
export class CustomCheckoutLoginComponent extends CheckoutLoginComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  checkoutLoginForm: UntypedFormGroup = this.formBuilder.group(
    {
      email: ['', [Validators.required, CustomValidators.emailValidator]],
      emailConfirmation: ['', [Validators.required, CustomValidators.emailValidator]],
    },
    {
      validators: CustomFormValidators.emailsMustMatch(
        'email',
        'emailConfirmation'
      ),
    }
  );

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected authRedirectService: AuthRedirectService,
    protected activeCartService: ActiveCartFacade,
    protected router: Router,
    protected authRedirectStorageService: AuthRedirectStorageService,
    protected semanticPathService: SemanticPathService,
  ) {
    super(formBuilder, authRedirectService, activeCartService);
  }

  onSubmit(): void {
    if (this.checkoutLoginForm.valid) {
      const email = this.checkoutLoginForm.get('email').value;
      this.activeCartService.addEmail(email);

      this.subscriptions.add(this.activeCartService.getAssignedUser().subscribe(() => {
        if (this.activeCartService.isGuestCart()) {
          this.authRedirectStorageService.setRedirectUrl(this.semanticPathService.get('checkout'));
          this.authRedirectService.redirect();
        }
      }));
    } else {
      this.checkoutLoginForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
